import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ClickAwayListener, Typography } from '@ori-ui/mui';
import { useCallback, useState } from 'react';
import { Tooltip, TooltipFab } from "./styles";
import { CATALOGUE_OFFER_TOOLTIP } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
var OFFER_TOOLTIP_LEAVE_DELAY = 2000;
export var CatalogueOfferTooltip = function CatalogueOfferTooltip(_ref) {
  var children = _ref.children,
    offerLabelSmallerOnMobile = _ref.offerLabelSmallerOnMobile,
    title = _ref.title;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var handleTooltipClose = useCallback(function () {
    return setIsOpen(false);
  }, []);
  var handleTooltipOpen = useCallback(function () {
    return setIsOpen(true);
  }, []);
  var toggleTooltip = useCallback(function (e) {
    e.preventDefault();
    setIsOpen(function (prevOpen) {
      return !prevOpen;
    });
  }, []);
  return /*#__PURE__*/_jsx(ClickAwayListener, {
    mouseEvent: false,
    onClickAway: handleTooltipClose,
    children: /*#__PURE__*/_jsx(Tooltip, {
      disableTouchListener: true,
      leaveDelay: OFFER_TOOLTIP_LEAVE_DELAY,
      open: isOpen,
      placement: "bottom-start",
      PopperProps: {
        disablePortal: true
      },
      title: /*#__PURE__*/_jsx(Typography, {
        variant: "body1",
        children: title
      }),
      "data-testid": CATALOGUE_OFFER_TOOLTIP,
      onClose: handleTooltipClose,
      onOpen: handleTooltipOpen,
      children: /*#__PURE__*/_jsx(TooltipFab, {
        disableRipple: true,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        onTouchEnd: toggleTooltip,
        children: children
      })
    })
  });
};
//# sourceMappingURL=CatalogueOfferTooltip.js.map